// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"a9a4ae73","247":"690eaab4","583":"c4304f44","710":"6d09e2da","878":"3c79f3e2","983":"41b81bd7"}[chunkId] + ".chunk.js";
};